import { apiClient } from '@/shared/lib/axios';
import type { Insurer } from '@/types/admin-insurer';

export type AdminInsurerResponse = {
  data: Insurer;
};

export const getInsurerDetail = async (
  siteType: string,
  id: number
): Promise<AdminInsurerResponse> => {
  const response = await apiClient.get<AdminInsurerResponse>(
    `/admin/${siteType}/insurers/${id}`
  );
  return response.data;
};

export const getInsurerCopyDetail = async (
  siteType: string,
  id: number
): Promise<AdminInsurerResponse> => {
  const response = await apiClient.get<AdminInsurerResponse>(
    `/admin/${siteType}/insurers/${id}/copy`
  );
  return response.data;
};
